import { render, staticRenderFns } from "./ManageClaim.vue?vue&type=template&id=13e5b37b&scoped=true&"
import script from "./ManageClaim.vue?vue&type=script&lang=js&"
export * from "./ManageClaim.vue?vue&type=script&lang=js&"
import style0 from "./ManageClaim.vue?vue&type=style&index=0&id=13e5b37b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e5b37b",
  null
  
)

export default component.exports